<template>
  <div v-show="isActive" class="map-tool-window search-tool-window" :id="isFixed ? 'searchIDFix' : 'searchID'">
    <div v-if="!isFixed" class="map-tool-window-header" :class="{ widgetHeader: !isFixed }" id="searchIDheader">
         <p class="map-tool-window-header-title">Buscador</p>
          <div class="map-tool-window-header-actions">
            <button class="control-btn" v-on:click="isHidden = !isHidden">
              <!-- <font-awesome-icon v-if="!isHidden" icon="minus"></font-awesome-icon>
              <font-awesome-icon v-else icon="plus"></font-awesome-icon> -->
            <svg  v-if="isHidden"
            viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <svg v-else
              viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
            <button class="control-btn" v-on:click="exitSearch()">
              <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
              <!-- <font-awesome-icon icon="times" v-on:click="exitSearch()"></font-awesome-icon> -->
            </button>
        </div>
    </div>
    <div
      v-show="!isHidden"
      class="map-tool-window-body search-tool-body"
    >
      <!-- Filtro -->
      <div class="search-filters">
        <label for="search-place-type">
          Filtrar por tipo:
        </label>

        <select
          id="search-place-type"
          v-model="placeTypeFilter"
          @change="applyFilter"
        >
          <option value="all">Todos los lugares</option>
          <option value="city">Ciudades</option>
          <option value="country">Países</option>
          <option value="state">Regiones/Estados</option>
        </select>
      </div>

      <!-- Buscador -->
      <div class="search-input">
        <AutoCompleteInput
          ref="autoCompleteInput"
          id="location"
          :value="searchInput"
          :options="searchList"
          attribute="formatted_display"
          beforeSearchMessage="Ingresa una ciudad o país"
          searchingMessage="Buscando lugares..."
          emptySearchResultsMessage="No se encontró ningún lugar con ese nombre"
          :error="searchError"
          @updated="waitForSearch"
          @itemSelected="setLocation"
        />
      </div>

      <!-- Resultado -->
      <section class="search-results" aria-live="polite">
        <div class="search-results-header">
          <img src="images/marker.svg" alt="">

          <h3>
            {{ searchLocation ? 'Lugar encontrado' : 'Resultados de búsqueda' }}
          </h3>
        </div>

        <div v-if="searchLocation" class="search-result-card">
          <div class="search-result-heading">
            <p class="search-result-name">
              {{ searchLocation.display_name }}
            </p>

            <span
              v-if="searchLocation.category"
              class="place-category"
            >
              {{ searchLocation.category }}
            </span>
          </div>

          <dl class="search-result-details">
            <div>
              <dt>Latitud</dt>
              <dd>{{ searchLocation.lat }}</dd>
            </div>

            <div>
              <dt>Longitud</dt>
              <dd>{{ searchLocation.lon }}</dd>
            </div>

            <div
              v-if="
                searchLocation.address &&
                searchLocation.address.country
              "
              class="search-result-country"
            >
              <dt>País</dt>
              <dd>{{ searchLocation.address.country }}</dd>
            </div>
          </dl>
        </div>

        <div v-else class="search-empty-state">
          <p>
            {{
              searchError
                ? 'No se encontraron coincidencias'
                : 'No hay resultados para mostrar'
            }}
          </p>

          <span>
            {{
              searchError
                ? 'Prueba con otro nombre o cambia el tipo de lugar.'
                : 'Escribe una ciudad, país o región en el buscador.'
            }}
          </span>
        </div>
      </section>

      <!-- Acciones -->
      <div v-if="searchLocation" class="search-actions">
        <button
          type="button"
          class="search-clear-btn"
          @click="cleanSearch"
        >
          Limpiar búsqueda
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AutoCompleteInput from '@/components/mapTools/search/AutoCompleteInput.vue'
import { draggableDiv } from '@/components/mixin/draggableDiv.js'
import { vuex } from '@/components/mixin/vuex.js'
import { mapService } from '@/services/map/mapService.js'
import { search } from './search.js'


export default {
  name: 'HelloWorld',
  props: ['isFixed'],
  mixins: [vuex, draggableDiv, search],
  data() {
    return {
      map: null,
      isHidden: false,
      searchInput: '',
      searchList: [],
      searchLocation: '',
      timeout: null,
      searchError: false,
      placeTypeFilter: 'all',
    }
  },
  components: {
    AutoCompleteInput
  },
  computed: {
    isActive: function () {
      return this.isFixed ? this.isMobile : this.mapToolValues('search').active && !this.isMobile
    }
  },
  methods: {
    applyFilter: function () {
      if (this.searchInput && this.searchInput.trim() !== '') {
        this.searchQuery(this.searchInput);
      }
    },
    searchQuery: function (query) {
      this.searchError = false;

      // URL base del servicio
      const nominatimUrl = process.env.VUE_APP_API_NOMINATIM;

      // Parámetros para optimizar búsqueda de ciudades y países
      const params = new URLSearchParams({
        format: 'json',
        q: query,
        addressdetails: 1,     // Obtener detalles del domicilio
        limit: 10,             // Limitar a 10 resultados
        featuretype: 'city,country,state' // Filtrar por tipo de lugar
      });

      // Construir la URL completa
      const url = `${nominatimUrl}search?${params.toString()}`;

      console.log("Buscando lugares:", url);

      const req = new XMLHttpRequest();
      req.open('GET', url, false);
      req.withCredentials = false;
      req.send();

      if (req.status == 200) {
        console.log("Búsqueda exitosa");
        const response = JSON.parse(req.response);

        if (response.length === 0) {
          console.log("No se encontraron resultados");
          this.searchError = true;
          this.searchList = [];
          return;
        }

        // Procesar y enriquecer los resultados
        this.searchList = response.map(place => {
          // Extraer información relevante
          const type = place.type || '';
          const category =
            type.includes('city') ? 'Ciudad' :
              type.includes('administrative') ? 'Región/Estado' :
                type.includes('country') ? 'País' :
                  'Lugar';

          return {
            ...place,
            category,
            // Conservar la dirección completa entregada por Nominatim.
            // Antes se reemplazaba por ciudad, región y país, lo que hacía
            // que ubicaciones distintas aparecieran con el mismo texto genérico.
            formatted_display: place.display_name
          };
        });

        console.log("Resultados procesados:", this.searchList);
      } else {
        console.error("Error en la búsqueda:", req.status);
        this.searchError = true;
        this.searchList = [];
      }
    },
    waitForSearch: function (newValue) {
      this.searchInput = newValue;
    },
    setLocation: function (location) {
      this.searchLocation = location;
      this.executeMapToolAction('search', 'setLocation', {
        lat: location.lat,
        lon: location.lon
      })
      this.addLocationMarker(location.lat, location.lon)
    },
    exitSearch: function () {
      this.cleanSearch()
      this.selectMapTool('search', false)
    },
    cleanSearch: function () {
      this.$refs.autoCompleteInput.setQuery('')
      this.executeMapToolAction('search', 'removeLocation', {})
      if (this.removeLoationMarker) {
        this.removeLoationMarker();
      }
    }
  },
  updated() {

  },
  created() {

  },
  mounted() {
    this.makeDraggable("searchID");
    this.map = mapService.get();
  },
  watch: {
    'searchInput': function (newValue, oldValue) {

      if (newValue == '') {
        this.searchList = [];
        this.searchLocation = null;
        this.$emit('onRemoveLocation');
        return;
      }

      clearTimeout(this.timeout);
      // Make a new timeout set to go off in 800ms
      this.timeout = setTimeout(function () {
        this.searchQuery(newValue);
      }.bind(this), 501);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search-tool-window {
  top: 4em;
  right: 16px;

  width: 380px;
  max-width: calc(100vw - 32px);

  z-index: 1000;
}
.search-filters {
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
  color: var(--color-navy);

  label {
    margin-right: 0.5em;
    font-weight: bold;
  }

  select {
    padding: 0.25em;
    border-radius: 4px;
    border: 1px solid var(--color-line);
    background-color: transparent;
    cursor: pointer;

  }
}
.search-tool-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.search-filters {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  align-items: center;
  gap: 10px;

  label {
    margin: 0;

    color: var(--color-navy);
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.3;
  }

  select {
    width: 100%;
    min-width: 0;
    min-height: 36px;

    padding: 7px 10px;

    background: var(--color-white);
    border: 1px solid var(--color-line);
    border-radius: 4px;

    color: var(--color-graphite);
    font-family: inherit;
    font-size: 0.85rem;

    cursor: pointer;

    &:hover {
      border-color: var(--color-steel);
    }

    &:focus {
      border-color: var(--color-steel);
      outline: 2px solid var(--color-fog);
      outline-offset: 1px;
    }
  }
}

.search-input {
  width: 100%;
  min-width: 0;
}

.search-results {
  padding-top: 12px;
  border-top: 1px solid var(--color-line);
}

.search-results-header {
  display: flex;
  align-items: center;
  gap: 7px;

  margin-bottom: 10px;

  img {
    width: 18px;
    height: 18px;
  }

  h3 {
    margin: 0;

    color: var(--color-navy);
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.3;
  }
}

.search-result-card {
  padding: 12px;

  background: var(--color-mist);
  border: 1px solid var(--color-line);
  border-radius: 4px;
}

.search-result-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;

  margin-bottom: 12px;
}

.search-result-name {
  margin: 0;

  color: var(--color-graphite);
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.4;
}

.place-category {
  flex-shrink: 0;

  padding: 3px 7px;

  background: var(--color-fog);
  border-radius: 4px;

  color: var(--color-navy);
  font-size: 0.72rem;
  font-weight: 600;
}

.search-result-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;

  margin: 0;

  div {
    min-width: 0;
  }

  dt {
    margin-bottom: 3px;

    color: var(--color-steel);
    font-size: 0.72rem;
    font-weight: 700;
  }

  dd {
    margin: 0;

    color: var(--color-graphite);
    font-size: 0.82rem;
    overflow-wrap: anywhere;
  }
}

.search-result-country {
  grid-column: 1 / -1;
}

.search-empty-state {
  padding: 18px 14px;

  background: var(--color-mist);
  border: 1px dashed var(--color-line);
  border-radius: 4px;

  text-align: center;

  p {
    margin: 0 0 5px;

    color: var(--color-graphite);
    font-size: 0.85rem;
    font-weight: 600;
  }

  span {
    color: var(--color-ghost);
    font-size: 0.78rem;
    line-height: 1.4;
  }
}

.search-actions {
  display: flex;
  justify-content: flex-end;

  padding-top: 12px;
  border-top: 1px solid var(--color-line);
}

.search-clear-btn {
  min-height: 34px;
  padding: 7px 12px;

  background: var(--color-white);
  border: 1px solid var(--color-line);
  border-radius: 4px;

  color: var(--color-graphite);
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 600;

  cursor: pointer;

  &:hover {
    background: var(--color-mist);
    border-color: var(--color-steel);
    color: var(--color-navy);
  }

  &:focus-visible {
    outline: 2px solid var(--color-steel);
    outline-offset: 2px;
  }
}
</style>
